import {
  API_ENDPOINT,
  useClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateMutation,
} from '../../@types/schema';

interface UseClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateMutation {
  options?: Parameters<
    typeof useClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateMutation
  >[0]['options'];
}

export default function useCourseContractHistoriesInflearnMarketingConfirmCreateMutation(
  props?: UseClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateMutation
) {
  return useClientApiV1CourseContractHistoriesInflearnMarketingConfirmCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_COURSE_CONTRACT_HISTORIES_INFLEARN_MARKETING_CONFIRM,
    ...props,
  });
}
